import { Home } from "@/views/website/home";
import { Contact } from "views/website/contact";
import Coaches from "@/views/coaches/coaches";
import Players from "@/views/players/players";
import Schedule from "@/views/schedule/schedule";
import Season from "@/views/schedule/season";
import PlayerInfo from "@/views/players/details/playerInfo";

interface Route {
  path: string;
  view: React.ComponentType;
  layout: string;
  title: string;
}

const Routes: Route[] = [
  {
    path: "/",
    view: Home,
    layout: "app",
    title: "Home"
  },
  {
    path: "/players",
    view: Players,
    layout: "app",
    title: "Players"
  },
  {
    path: "/:playerName",
    view: PlayerInfo,
    layout: "app",
    title: "Players"
  },
  {
    path: "/coaches",
    view: Coaches,
    layout: "app",
    title: "Coaches"
  },
  {
    path: "/schedule",
    view: Schedule,
    layout: "app",
    title: "Schedule"
  },
  {
    path: "/schedule/:season",
    view: Season,
    layout: "app",
    title: "Schedule"
  },
  {
    path: "/contact",
    view: Contact,
    layout: "app",
    title: "Contact Us"
  },
];

export default Routes;
